import { ID } from 'shared/types/id';
import { lifeAreaOtherID } from 'shared/types/orderable-section';
import { SortingMode } from 'shared/types/sorting-mode';

import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

export const updateTodayLifeAreaTaskOrder = async (
  lifeAreaSorting: { lifeAreaId: ID; taskIds: ID[] }[],
) => {
  const user = await getUser();
  // without a user we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  const settingsToUpdate = lifeAreaSorting.reduce<
    Record<string, ID[] | SortingMode>
  >(
    (acc, { lifeAreaId, taskIds }) => {
      acc[
        `settings.todayGroupSorting.lifeArea.sorting.${lifeAreaId === lifeAreaOtherID ? null : lifeAreaId}`
      ] = taskIds;
      return acc;
    },
    {
      'settings.todoSortingMode': SortingMode.Custom,
    },
  );

  updateDocWithTimestamp(userRef, settingsToUpdate);
};
